import { defineComponent, ref, onMounted, onBeforeUnmount, watch, createElementBlock, openBlock, normalizeStyle, createElementVNode } from 'vue';
import { useElementVisibility, useDocumentVisibility } from './basler-components.es419.js';
import { HeroCanvasRenderer } from './basler-components.es421.js';

const _hoisted_1 = { class: "hero-canvas-background__outer" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HeroCanvasBackground",
  props: {
    colorMode: { default: "dark" },
    color1: { default: "#1D3EA5" },
    color2: { default: "#1D305F" },
    color3: { default: "#38068a" },
    usePostProcessing: { type: Boolean, default: false },
    useUnrealBloom: { type: Boolean, default: false },
    progress: { default: 0.95 },
    effectOpacity: { default: 0 }
  },
  setup(__props) {
    const props = __props;
    const _color1 = ref(
      props.colorMode == "light" || props.colorMode == "dark" ? "#011C53" : props.colorMode == "dark-purple" ? "#743ac2" : props.color1
    );
    const _color2 = ref(
      props.colorMode == "light" || props.colorMode == "dark" ? "#002FA6" : props.colorMode == "dark-purple" ? "#2e185e" : props.color2
    );
    const _color3 = ref(
      props.colorMode == "light" || props.colorMode == "dark" ? "#002a95" : props.colorMode == "dark-purple" ? "#38068a" : props.color3
    );
    const usePostProcessing = ref(props.usePostProcessing);
    const useUnrealBloom = ref(props.useUnrealBloom);
    const webglcanvas = ref(null);
    let heroCanvasRenderer = null;
    const wrapper = ref(null);
    const wrapperIsVisible = useElementVisibility(wrapper);
    const documentVisibility = useDocumentVisibility();
    const onWindowResizeFunction = () => {
      heroCanvasRenderer?.onResize();
    };
    const cleanupRenderer = () => {
      window.removeEventListener("resize", onWindowResizeFunction);
      if (heroCanvasRenderer) {
        heroCanvasRenderer.dispose();
        heroCanvasRenderer = null;
      }
    };
    onMounted(() => {
      if (webglcanvas.value) {
        heroCanvasRenderer = new HeroCanvasRenderer({
          progress: props.progress,
          speed: 0.055,
          color1: _color1.value,
          color2: _color2.value,
          showDebugControls: false,
          usePostProcessing: usePostProcessing.value,
          useUnrealBloom: useUnrealBloom.value
        });
        heroCanvasRenderer.init(webglcanvas.value);
      }
      window.addEventListener("resize", onWindowResizeFunction, {
        passive: true
      });
    });
    onBeforeUnmount(() => {
      cleanupRenderer();
    });
    watch(
      () => props.colorMode,
      () => {
        _color1.value = props.colorMode == "light" || props.colorMode == "dark" ? "#011C53" : props.colorMode == "dark-purple" ? "#743ac2" : props.color1;
        _color2.value = props.colorMode == "light" || props.colorMode == "dark" ? "#002FA6" : props.colorMode == "dark-purple" ? "#2e185e" : props.color2;
        _color3.value;
        props.colorMode == "light" || props.colorMode == "dark" ? "#002a95" : props.colorMode == "dark-purple" ? "#38068a" : props.color3;
        heroCanvasRenderer?.setColor1(_color1.value);
        heroCanvasRenderer?.setColor2(_color2.value);
      },
      { deep: true }
    );
    watch(
      () => props.progress,
      (progressValue) => {
        heroCanvasRenderer?.setProgress(progressValue);
      },
      { deep: true }
    );
    watch(
      wrapperIsVisible,
      (newVal) => {
        heroCanvasRenderer?.setPaused(!newVal);
      },
      { immediate: true, deep: true }
    );
    watch(
      documentVisibility,
      (newVal) => {
        if (newVal === "hidden") {
          heroCanvasRenderer?.setPaused(true);
        } else if (wrapperIsVisible.value) {
          heroCanvasRenderer?.setPaused(false);
        }
      },
      { immediate: true, deep: true }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "hero-canvas-background",
        ref_key: "wrapper",
        ref: wrapper,
        style: normalizeStyle([{ "--color-canvas": _ctx.colorMode === "dark-purple" ? "#38068a" : "#002a95" }])
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", {
            class: "hero-canvas-background__inner",
            style: normalizeStyle(`--effect-opacity: ${_ctx.effectOpacity}`)
          }, [
            createElementVNode("canvas", {
              class: "hero-canvas-background__canvas",
              ref_key: "webglcanvas",
              ref: webglcanvas
            }, null, 512),
            _cache[0] || (_cache[0] = createElementVNode("div", { class: "hero-canvas-background__filter" }, null, -1))
          ], 4)
        ])
      ], 4);
    };
  }
});

export { _sfc_main as default };
